import { useContext, useState, useSyncExternalStore } from "react"
import { BenefitEditorContext } from "./benefitEditorContext"
import type { EditorAddress, GrantInformationTab, GrantView } from "./benefitEditorSlice"

const noSubscribe = () => () => {}
type Selection = Omit<GrantView, keyof EditorAddress>

/** Non-URL task choices survive panel/route unmount; shared standalone controls stay local. */
export function useGrantView() {
  const controller = useContext(BenefitEditorContext)
  const [local, setLocal] = useState<Selection | null>(null)
  const stored = useSyncExternalStore(controller?.store.subscribe ?? noSubscribe,
    () => controller?.grantView() ?? null, () => null)
  return {
    view: controller ? stored : local,
    select(view: Selection) { if (controller) controller.selectGrantView(view); else setLocal(view) },
    close() { if (controller) controller.closeGrantView(); else setLocal(null) },
    changeTab(tab: GrantInformationTab) {
      if (controller) controller.changeGrantTab(tab)
      else setLocal(previous => previous ? { ...previous, tab } : null)
    },
  }
}
